<template>
  <section class="OMS">
    <div class="filter">
      <button @click="showSideFilter = !showSideFilter">
        <i class="fas fa-filter"></i>
      </button>
      <input
        type="text"
        name=""
        v-model="search"
        placeholder="Buscar por número do pedido. Ex: 123456"
      />
    </div>

    <div class="sideFilter" v-if="showSideFilter">
      <div class="sideFilter__header">
        <h2>Filtros</h2>
        <i class="fas fa-times" @click="showSideFilter = false"></i>
      </div>

      <div class="sideFilter__period">
        <h3><i class="far fa-calendar-alt"></i> Período</h3>
        <p @click="showFilterPedido = !showFilterPedido">Data do Pedido</p>
        <div v-if="showFilterPedido" class="period__date">
          <div class="form-group">
            <label for="">Data Início</label>
            <input type="date" v-model="dataInicio" />
          </div>
          <div class="form-group">
            <label for="">Data Fim</label>
            <input type="date" v-model="dataFim" />
          </div>
          <button class="period__search" @click="getData(true)">Buscar</button>
        </div>
      </div>

      <div class="sideFilter__status">
        <h3><i class="fas fa-filter"></i> Status </h3>
        <span class="selectAll" @click="selectAll('status')">Selecionar todos</span>
        <span class="removeAllSelected" @click="removeAllSelected('status')">Remover todos</span>
        <br>
        <p @click="showFilterStatus = !showFilterStatus">Status</p>

        <div v-if="showFilterStatus" class="status__options">
          <div class="row" v-for="(status, i) in filters.Status" :key="i">
            <v-checkbox
              @change="getData(true)"
              v-model="statusSelected"
              :label="status"
              :value="status"
            ></v-checkbox>
          </div>
        </div>
      </div>

      <div class="sideFilter__salesChannel">
        <h3><i class="fas fa-exchange-alt"></i> Canal de Vendas</h3>
        <span class="selectAll" @click="selectAll('channel')">Selecionar todos</span>
        <span class="removeAllSelected" @click="removeAllSelected('channel')">Remover todos</span>
        <br>
        <p @click="showFilterCanaVendas = !showFilterCanaVendas">
          Canal de Vendas
        </p>

        <div v-if="showFilterCanaVendas" class="salesChannel__options">
          <div class="row" v-for="(canais, i) in filters.SalesChannel" :key="i">
            <v-checkbox
              @change="getData(true)"
              v-model="canaisSelected"
              :label="canais"
              :value="canais"
            ></v-checkbox>
          </div>
        </div>
      </div>

      <div class="sideFilter__paymentMethods">
        <h3>
          <i class="fas fa-money-bill-wave-alt"></i> Formas de Pagamento
        </h3>
        <span class="selectAll" @click="selectAll('payment')">Selecionar todos</span>
        <span class="removeAllSelected" @click="removeAllSelected('payment')">Remover todos</span>
        <br>
        <p @click="showFilterFormasPagamento = !showFilterFormasPagamento">
          Formas de Pagamento
        </p>

        <div v-if="showFilterFormasPagamento" class="paymentMethods__options">
          <div class="row" v-for="(pagamento, i) in filters.Pagamento" :key="i">
            <v-checkbox
              @change="getData(true)"
              v-model="pagamentoSelected"
              :label="pagamento"
              :value="pagamento"
            ></v-checkbox>
          </div>
        </div>
      </div>

      <div class="sideFilter__paymentMethods">
        <h3>
          <i class="fas fa-user"></i> Vendedores
        </h3>
        <span class="selectAll" @click="selectAll('salesman')">Selecionar todos</span>
        <span class="removeAllSelected" @click="removeAllSelected('salesman')">Remover todos</span>
        <br>
        <p @click="showFilterVendedores = !showFilterVendedores">
          Vendedores
        </p>

        <div v-if="showFilterVendedores" class="paymentMethods__options">
          <div class="row" v-for="(vendedor, i) in filters.Vendedor" :key="i">
            <v-checkbox
              @change="getData(true)"
              v-model="vendedorSelected"
              :label="vendedor"
              :value="vendedor"
            ></v-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="resume">
      <div class="resume__item">
        <div class="item__image">
          <i class="fas fa-shopping-cart"></i>
        </div>
        <div class="item__text">
          <h3>VENDAS TOTAIS</h3>
          <p>{{ infos.length }}</p>
        </div>
      </div>
      <div class="resume__item">
        <div class="item__image">
          <i class="fas fa-chart-bar"></i>
        </div>
        <div class="item__text">
          <h3>TICKET MÉDIO</h3>
          <p v-if="infos.length > 0">
            {{ (total / infos.length) | toCurrency }}
          </p>
          <p v-else>{{ 0 | toCurrency }}</p>
          <p v-if="loader">R$ 0,00</p>
        </div>
      </div>
      <div class="resume__item">
        <div class="item__image">
          <i class="fas fa-money-bill-alt"></i>
        </div>
        <div class="item__text">
          <h3>RECEITA TOTAL</h3>
          <p>{{ total | toCurrency }}</p>
        </div>
      </div>
    </div>

    <v-app>
      <!-- Table -->
      <template>
        <v-data-table
          :headers="headers"
          :items="infos"
          :items-per-page="10"
          :search="search"
          :footer-props="{
            'items-per-page-text':'Itens por página'
          }"
        >
        <template slot="no-data">
          <div>Nenhum item á ser exibido</div>
        </template>

          <template v-slot:item="{ item }">
            <tr class="customTr">

              <td>{{ moment(item.date).format("DD/MM/YYYY HH:mm:ss") }}</td>
              <td>
                <router-link
                  :to="'/panel/orders/DetailsOrder?Pedido=' + item.ov"
                  >{{ item.ov }}</router-link
                >
              </td>
              <td>{{ item.cliente }}</td>
              <td v-if="item.temServico == true">
                <i class="fas fa-tools servico" title="Pedido com Instalação"></i
                >{{ item.produtos.length }}
              </td>
              <td v-if="item.temServico == false">
                {{ item.produtos.length }}
              </td>
              <td>{{ item.valor | toCurrency }}</td>
              <td>{{ item.origem }}</td>
             
              <td v-if="item.pagamento == 'VISA ' || item.pagamento == 'VISA'">
                <i class="fab fa-cc-visa"></i> <br />
                {{ item.pagamento }}
              </td>
              <td
                v-else-if="
                  item.pagamento == 'MASTERCARD ' ||
                  item.pagamento == 'MASTER DEBITO' ||
                  item.pagamento == 'MASTERCARD'
                "
              >
                <i class="fab fa-cc-mastercard"></i> {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'ELO' || item.pagamento == 'ELO '">
                <i class="far fa-credit-card"></i> <br />
                {{ item.pagamento }}
              </td>
              <td
                v-else-if="
                  item.pagamento == 'HIPERCARD' || item.pagamento == 'HIPERCARD '
                "
              >
                <i class="far fa-credit-card"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'BOLETO BANCARIO'">
                <i class="fas fa-barcode"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'DEPOSITO'">
                <i class="fas fa-university"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'DINHEIRO'">
                <i class="fas fa-money-bill-alt"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'FINANCIAMENTO'">
                <i class="fas fa-piggy-bank"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'CARTAO BNDES'">
                <i class="fas fa-credit-card"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'AMERICAN EXPRESS'">
                <i class="fab fa-cc-amex"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'BOLETO PARCELADO'">
                <i class="far fa-window-restore"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'VALE'">
                <i class="fas fa-money-bill-wave-alt"></i> <br />
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'DEPOSITO A PRAZO'">
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'DEPOSITO PARA 45 DIAS'">
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'BOLETO PARA 15 DIAS'">
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'BOLETO PARA 45 DIAS'">
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == 'PIX'">
                {{ item.pagamento }}
              </td>
              <td v-else-if="item.pagamento == '-'">{{ item.pagamento }}</td>
              <td v-else>{{ item.pagamento }}</td>

              <td>{{ item.status }}</td>
              <td>{{ item.vendedor }}</td>
              <td>{{ item.parceiro }}</td>
              <td>
                <i v-if="item.temRTSolar" class="fas fa-check-circle"></i>
              </td>
            </tr>
          </template>

          <!-- Footer -->
          <template v-slot:[`footer.page-text`]="items"> 
            {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
          </template>
        </v-data-table>
      </template>

      <div class="mb-10"></div>
      <!-- Dialogs -->
      <!-- Loading -->
      <v-dialog v-model="loading.active" persistent width="300">
        <v-card color="var(--standardGreen)" dark>
          <v-card-text style="padding: 27px">
            <div v-html="loading.message"></div>
            <v-progress-linear
              style="margin-top: 15px"
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-app>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: null,
      showSideFilter: false,
      showFilterPedido: false,
      showFilterStatus: false,
      showFilterCanaVendas: false,
      showFilterFormasPagamento: false,
      showFilterVendedores: false,
      infos: [],
      pedidos: [],
      infosCabecalho: [],
      paginaAtual: 0,
      loader: false,
      token: null,
      total: 0,
      filters: [],
      statusSelected: [],
      canaisSelected: [],
      pagamentoSelected: [],
      vendedorSelected: [],
      dataInicio: null,
      dataFim: null,
      loading: {
        active: false,
        message: null
      },
      headers: [
        { text: 'Data', value: 'date' },
        { text: 'Pedido', value: 'ov' },
        { text: 'Cliente', value: 'cliente' },
        { text: 'Produtos', value: 'produtos' },
        { text: 'Valor', value: 'valor' },
        { text: 'Origem', value: 'origem' },
        { text: 'Pagamento', value: 'pagamento' },
        { text: 'Status', value: 'status' },
        { text: 'Vendedor', value: 'vendedor' },
        { text: 'Parceiro', value: 'parceiro' },
        { text: 'RT', value: 'temRTSolar' }
      ]
    };
  },

  created() {

    this.loading.message = "Buscando dados! Aguarde...";
    this.loading.active = true;

    let dados = JSON.parse(localStorage.getItem("login"));
    this.token = dados.token;

    // Busca os filtros da página
    axios.get(
      `https://www.leverosintegra.com.br/map/api/OMS/${this.token}`
    ).then(res => {
      if (res && res.status === 200) {
        // Recupera filtros
        this.filters = res.data;

        // Recupera a data atual para a primeira busca
        this.dataInicio = this.getCurrentDate()
        this.dataFim = this.getCurrentDate()

        // Recupera filtros
        this.statusSelected = this.filters.Status;
        this.canaisSelected = this.filters.SalesChannel;
        this.pagamentoSelected = this.filters.Pagamento;
        this.vendedorSelected = this.filters.Vendedor;
        
        // Chama a função responsável por buscar os pedidos
        this.getData()
      }
    }).catch(err => {
      console.log(err)
      this.loading.active = false;
      return alert('Erro ao buscar dados: ' + err)
    })
  },

  methods: {
    getData(filter) {

      if (filter) {
        this.infos = [];
        this.total = 0;
        this.loading.message = "Buscando dados! Aguarde...";
        this.loading.active = true;
        window.scrollTo(0,0);
      }

      // Busca de Dados com os filtros
      axios.post(
        `https://www.leverosintegra.com.br/map/api/OMS/`,
        {
          FiltroFaturamento: false,
          DtInicial: this.dataInicio,
          DtFinal: this.dataFim,
          Status: this.statusSelected,
          SalesChannel: this.canaisSelected,
          Pagamento: this.pagamentoSelected,
          Vendedor: this.vendedorSelected
        }
      ).then(res => {
        if (res && res.status === 200) {
          // Recupera items do response
          this.infos = res.data.lPedidos;
          // Calcula o valor total de pedidos
          this.infos.forEach(el => {
            this.total += el.valor
          })

          this.loading.active = false;
        }
      }).catch(err => {
        this.loading.active = false;
        alert('Erro ao buscar dados:' + err)
        console.log(err)
      })
    },

    selectAll(filter) {
      if (filter === 'status') {
        this.statusSelected = this.filters.Status;
      }
      if (filter === 'channel') {
        this.canaisSelected = this.filters.SalesChannel;
      }
      if (filter === 'payment') {
        this.pagamentoSelected = this.filters.Pagamento;
      }
      if (filter === 'salesman') {
        this.vendedorSelected = this.filters.Vendedor;
      }

      this.getData(true);
    },

    removeAllSelected(filter) {
      if (filter === 'status') {
        this.statusSelected = [];
      }
      if (filter === 'channel') {
        this.canaisSelected = [];
      }
      if (filter === 'payment') {
        this.pagamentoSelected = [];
      }
      if (filter === 'salesman') {
        this.vendedorSelected = [];
      }
    },

    getCurrentDate() {
      // Inicializa a primeira data a ser buscada (Dia atual)
      let data = new Date();
      
      let dia = data.getDate();
      let mes = data.getMonth() + 1;
      let ano = data.getFullYear();

      dia = dia.toString().length === 1 ? '0' + dia : dia;
      mes = mes.toString().length === 1 ? '0' + mes : mes;


      return `${ano}-${mes}-${dia}`;
    }

  }
};
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
  max-height: 20px;
}
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding-top: 50px;

  i {
    color: var(--customBlue);
    margin-top: 30px;
  }

  span:nth-child(2) {
    padding-top: 10px;
    font-size: 0.95rem;
  }
}

.paggination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  position: absolute;

  @media (min-width: 441px) {
    position: initial;
  }

  &__button {
    background: var(--standardGreen);
    color: var(--customWhite);
    border-radius: 5px;
    padding: 5px;
    outline: none;
  }

  &__input {
    border: 1px solid var(--customGray-200);
    border-radius: 5px;
    width: 10%;
    text-align: center;
    margin: 0 10px;
    padding: 5px;

    @media (min-width: 441px) {
      width: 5%;
    }
  }

  p {
    margin: 0 10px;
    color: var(--customGray-500);
    font-size: 0.95rem;

    span {
      font-weight: bold;
    }
  }
}

.pagginationHeader {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  right: 20px;
  margin: 0 0 5px 0;
  z-index: -1;

  @media (min-width: 441px) {
    position: initial;
    margin: 20px 0;
  }

  &__button {
    background: var(--standardGreen);
    color: var(--customWhite);
    border-radius: 5px;
    padding: 5px;
    outline: none;
  }

  &__input {
    border: 1px solid var(--customGray-200);
    border-radius: 5px;
    width: 10%;
    text-align: center;
    margin: 0 10px;
    padding: 5px;

    @media (min-width: 441px) {
      width: 5%;
    }
  }

  p {
    margin: 0 10px;
    color: var(--customGray-500);
    font-size: 0.95rem;

    span {
      font-weight: bold;
    }
  }
}

.OMS {
  width: 90%;
  margin: 0 auto;
  padding-top: 50px;
}

.filter {
  button {
    background: var(--standardGreen);
    padding: 9px;
    border-radius: 5px 0 0 5px;
    color: var(--customWhite);
    outline: none;
    width: 10%;
    vertical-align: middle;

    @media (min-width: 441px) {
      width: 5%;
    }
  }

  input {
    border: 1px solid var(--customGray-200);
    padding: 9px;
    border-radius: 0 5px 5px 0;
    width: 90%;
    outline: none;
    font-size: 0.95rem;

    @media (min-width: 441px) {
      width: 95%;
    }
  }
}

.sideFilter {
  z-index: 1;
  background: var(--customWhite);
  position: absolute;
  box-shadow: 0 4px 10px var(--customGray-200);
  right: 0;
  width: 80%;
  top: 0;
  min-height: 100%;
  padding: 20px;

  @media (min-width: 441px) and (max-width: 800px) {
    width: 50%;
  }
  @media (min-width: 801px) {
    width: 35%;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 50px 0 20px 0;

    h2 {
      color: var(--customGray-500);
    }

    i {
      color: var(--customGray-500);
      cursor: pointer;
    }
  }

  &__period,
  &__status,
  &__salesChannel,
  &__paymentMethods {
    margin-bottom: 25px;

    h3 {
      padding-bottom: 10px;
      color: var(--customGray-500);
      font-size: 1.1rem;
    }

    p {
      border: 1px solid var(--customGray-200);
      cursor: pointer;
      padding: 7px;
      color: var(--standardGreen);
      font: 700 0.95rem "Soleto", sans-serif;
    }

    .status,
    .salesChannel,
    .paymentMethods {
      &__options {
        border: 1px solid var(--customGray-200);
        padding: 10px;

        label {
          padding-left: 10px;
        }

        input {
          cursor: pointer;
        }
      }
    }

    .period {
      &__date {
        border: 1px solid var(--customGray-200);
        padding: 20px 10px;

        input {
          border: 1px solid var(--customGray-200);
          border-radius: 5px;
          padding: 4px;
          margin: 10px 0;
          width: 40%;
          font-size: 0.95rem;
        }

        label {
          font-size: 0.95rem;
        }
      }

      &__search {
        background: var(--standardGreen);
        color: var(--customWhite);
        padding: 10px;
        border-radius: 5px;
        margin-right: 10px;
        outline: none;
      }
    }
  }
}

.resume {
  display: flex;
  align-items: center;
  background: #4cdddd1e;
  justify-content: space-between;
  padding: 30px;
  flex-direction: column;

  @media (min-width: 801px) {
    flex-direction: row;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 15px 0;

    @media (min-width: 801px) {
      padding: 0;
    }

    .item {
      &__image {
        padding-right: 15px;
        i {
          font-size: 3.125rem;
          color: var(--customGray-200);
        }
      }

      &__text {
        h3 {
          color: var(--customGray-200);
          font-size: 0.95rem;
        }

        p {
          color: var(--customGray-500);
          font-size: 1.6rem;
          padding-top: 5px;
        }
      }
    }
  }
}

.table {
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    margin-top: 30px;

    thead {
      tr {
        th {
          padding: 10px 5px;
          color: var(--standardGreen);
          border-bottom: 1px solid var(--customGray-200);
          font-size: 0.95rem;
        }
      }
    }

    tbody {
      tr {
        &:hover {
          background: #4cdddd1e;
        }
        td {
          text-align: center;
          padding: 20px 10px;
          border-bottom: 1px solid var(--customGray-200);
          font-size: 0.95rem;
          color: var(--customGray-800);

          a {
            color: var(--standardGreen);
            font-weight: bold;
          }

          i {
            font-size: 1.563rem;
            padding: 10px;
            color: var(--standardGreen);
          }

          .servico {
            font-size: 0.95rem;
          }
        }
      }
    }
  }
}
.text-start {
  padding: 0px !important;
}

.customTr {
  &:hover {
    background: #4cdddd1e;
  }
  td {
    text-align: center;
    padding: 20px 10px;
    font-size: 0.95rem;
    color: var(--customGray-800);

    a {
      color: var(--standardGreen);
      font-weight: bold;
    }

    i {
      font-size: 1.563rem;
      padding: 10px;
      color: var(--standardGreen);
    }

    .servico {
      font-size: 0.95rem;
    }
  }
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--customGray-500);
}

::-webkit-scrollbar {
  height: 8px;
  background: var(--customGray-100);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--customBlue);
  border-radius: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.row {
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.selectAll {
  color: grey;
  font-size: 0.9rem;
  cursor: pointer;
}

.removeAllSelected {
  color: red;
  font-size: 0.9rem;
  float: right;
  cursor: pointer;
}

::v-deep .v-application--wrap {
  min-height: fit-content !important;
}
</style>